import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'


const ProjectDetail3 = () => {
  return (
   <Container fluid className='project-section'>
    <div className='project-photo'>
        <div>
        <img className='img-fluid' src="https://i.ibb.co/KqTvqLF/1.png" alt="1" border="0"/>
        </div>
        <div >
        <img className='img-fluid' src="https://i.ibb.co/Lh5wpFd/2.png" alt="Screen-Shot-Tool-20221211190639" border="0"/>
        </div>
        <div >
        <img className='img-fluid ' src="https://i.ibb.co/rHQMHK0/3.png" alt="Screen-Shot-Tool-20221211190610" border="0"/>
        </div>
    </div>

    <div className='my-5 w-75 mx-auto text-white '>
               <h1>Project Description</h1>
               <p >This is a website of Buying and Selling the used cars here they can bu a car for such a cheap price</p>
               <ul className='text-strat'>
                 <li></li> 
                 <li>React Hot Toast Is Used For Assuring User Of Any Task</li>
                 <li>Secure User Authentication </li> 
                 <li>This is a User Friendly </li>
                 <li>There are three role implemented 1.admin 2.buyer/user 3.seller</li>
                 <li>Admin add add delete any buyer or any user</li>
                 <li>Buyer can add their cars</li>
                 <li>Private Route Is used to secure resist unwanted people</li>
               </ul>
               <div>
                <a className='btn btn-primary mx-1' target={"_blank"} href="https://fir-auth-practice-9715f.firebaseapp.com/">Live Site</a>
                <a className='btn btn-primary mx-1' target={"_blank"} href ="https://github.com/lalon147/sekhanei-dot-com">Client Side Link</a>
                <a className='btn btn-primary mx-1' target={"_blank"} href ="https://github.com/lalon147/sekhanei-server">Server Side Link</a>
               </div>
    </div>
              

   </Container>
  )
}

export default ProjectDetail3